import styled from 'styled-components';

import { StyledControlBarButton } from '../control-bar-button.styles';

export const StyledSearchButton = styled(StyledControlBarButton)`
  &:hover {
    svg circle {
      stroke: ${({ theme }) =>
        theme.themeColors.controlBar.rightPanel.icons.searchIcon
          .colorOnHover};
    }
    svg path {
      fill: ${({ theme }) =>
        theme.themeColors.controlBar.rightPanel.icons.searchIcon
          .colorOnHover};
    }
  }
  &:active {
    svg circle {
      stroke: ${({ theme }) =>
        theme.themeColors.controlBar.rightPanel.icons.searchIcon
          .colorOnActive};
    }
    svg path {
      fill: ${({ theme }) =>
        theme.themeColors.controlBar.rightPanel.icons.searchIcon
          .colorOnActive};
    }
  }
`;

export const EditorToggleBlock = styled.div`
  font-size: 12px;
  display: grid;
  justify-content: center;
  align-items: center;
  text-align: left;
  gap: 10px;
  grid-template-columns: 1fr 110px;
  & > i {
    display: none;
  }
  @media all and (max-width: 1200px) {
    grid-template-columns: 1fr 1fr;
    & > span {
      display: none;
    }
    & > i {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
`;